import { pathExists } from 'fs-extra';
import { Logger } from '../utils/logger';
import { FileWriter } from '../utils/file-writer';
import { replaces } from '../configs/ci-build-yml-config';

export class CIBuildYmlUpgrader {
    private filePath: string;
    private fileWriter: FileWriter;

    private messages = {
        notFound: ''
    };

    /**
     * the constructor.
     * @param filePath the file path.
     * @param fileName the file name.
     */
    constructor(filePath: string, fileName?: string) {
        this.filePath = filePath;
        this.messages.notFound = `${fileName} not found at ${this.filePath}.`
    }

    /**
     * the run function to resolve the errors.
     */
    public async run(): Promise<void> {
        try {
            const exists = await pathExists(this.filePath);

            if (exists) {
                this.fileWriter = new FileWriter(this.filePath);

                this.fileWriter
                    .replaceContent(replaces)
                    .writeFile();
            } else {
                    Logger.log(this.messages.notFound);
            }
        } catch (error) {
            Logger.error(error);
        }
    }
}
